import React, { FC } from 'react'

const Footer: FC = () => <div style={{ marginBottom: '10px' }}/>

export default Footer
